import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Pagination, Response } from '@ui/src';
import { ColumnItems } from '../../../../components/export-column/types';
import { exportPspApi } from '../services';

export interface ExportAccountsState {
  accounts: ColumnItems[];
  pagination?: Pagination;
}

const initialState: ExportAccountsState = {
  accounts: [],
};

export const exportAccountsSlice = createSlice({
  name: 'exportAccounts',
  initialState,
  reducers: {
    clearAccounts: (state) => {
      state.accounts = [];
      state.pagination = undefined;
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      exportPspApi.endpoints.getExportPspAccounts.matchFulfilled,
      (
        state,
        action: PayloadAction<
          Response<{ account: { id: string; fullNumber: string } }>
        > & {
          meta: {
            arg: {
              originalArgs: {
                query: string;
              };
            };
          };
        },
      ) => {
        let nextAccounts: ColumnItems[] = [];

        if (
          action?.meta?.arg?.originalArgs?.query?.includes('cursor') &&
          state.accounts
        ) {
          nextAccounts = ([] as ColumnItems[]).concat(state.accounts);
        }

        action.payload.data?.edges?.forEach((item) => {
          if (
            !nextAccounts?.find(
              (account) => item.node.account.id === account.id,
            )
          ) {
            nextAccounts.push({
              id: item.node.account.id,
              name: item.node.account.fullNumber,
            });
          }
        });

        state.accounts = nextAccounts;

        state.pagination = action.payload.data.pageInfo;
      },
    );
  },
});

export const { clearAccounts } = exportAccountsSlice.actions;

export default exportAccountsSlice.reducer;
